<div class="w-100 flex-col" >
  <h3>Additonal Addresses</h3>
  <table mat-table [dataSource]="dataSource" matSort class="w-100 addressesContainer table-stack-sm">
    <ng-container matColumnDef="street">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="stack-full"> Street</th>
      <td mat-cell *matCellDef="let address" class="stack-full stack-strong"> {{address.streetAddress1}} </td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> City</th>
      <td mat-cell *matCellDef="let address"> {{address.city}} </td>
    </ng-container>
    <ng-container matColumnDef="zip">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Zip</th>
      <td mat-cell *matCellDef="let address"> {{address.zipCode}} </td>
    </ng-container>
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> State</th>
      <td mat-cell *matCellDef="let address"> {{address.state}} </td>
    </ng-container>
    <ng-container matColumnDef="county">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="stack-last"> County</th>
      <td mat-cell *matCellDef="let address" class="stack-last" data-label="County" [class.stack-empty]="!address.county"> {{address.county}} </td>
    </ng-container>

    <!-- Actions Column -->
    @if (!readOnly()) {
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="stack-end"> Actions </th>
        <td mat-cell *matCellDef="let address" class="ws-nowrap stack-end">
          <button  mat-icon-button color="primary" (click)="onEditAddress(address)" matTooltip="Edit address">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="onDeleteAddress(address)" matTooltip="Delete address">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let address; columns: displayedColumns;"></tr>
  </table>
</div>